import { request } from 'utils/request';
import { IWarehouseFilters } from './slice/types';

const resourceApi = {
  getAllResourceTypes: () => {
    return request({
      url: 'resource-type',
    });
  },
  getResourcesByType: (envId: number, typeId: number) => {
    return request({
      url: `hiiko_environment/${envId}/resources/by-type/${typeId}`,
    });
  },

  getUsedResourcesDistribution: ({
    envId,
    taskCategoryId,
    companyId,
    companyGroupId,
    filters,
    seasonId,
  }: {
    envId: number;
    taskCategoryId: number;
    companyId: number | null;
    companyGroupId: number | null;
    seasonId: number;
    filters: IWarehouseFilters;
  }) => {
    return request({
      url: `hiiko_environment/${envId}/used-resources/${taskCategoryId}`,
      params: {
        company_id: companyId ?? undefined,
        company_group_id: companyGroupId ?? undefined,

        culture_id: filters.cultureId,
        start_date: filters.startDate,
        end_date: filters.endDate,
        name: filters.search || undefined,
        season_id: seasonId,
      },
    });
  },

  getUsedResourcesDistributionByResource: ({
    envId,
    seasonId,
    resourceId,
    taskCategoryId,
    companyId,
    companyGroupId,
    filters,
  }: {
    envId: number;
    seasonId: number;
    resourceId: number;
    taskCategoryId: number;
    companyId: number | null;
    companyGroupId: number | null;

    filters: IWarehouseFilters;
  }) => {
    return request({
      url: `hiiko_environment/${envId}/used-resources/by-resource/${resourceId}`,
      params: {
        season_id: seasonId,
        company_id: companyId ?? undefined,
        company_group_id: companyGroupId ?? undefined,

        culture_id: filters.cultureId,
        start_date: filters.startDate,
        end_date: filters.endDate,
        name: filters.search || undefined,
        task_category_id: taskCategoryId,
      },
    });
  },
  getYieldSum: ({
    envId,
    companyId,
    companyGroupId,
  }: {
    envId: number;
    companyId: number | null;
    companyGroupId: number | null;
  }) => {
    return request({
      url: `hiiko_environment/${envId}/yield`,
      params: {
        company_id: companyId ?? undefined,
        company_group_id: companyGroupId ?? undefined,
      },
    });
  },

  getYieldByCultureAndCompany: ({
    envId,
    companyId,
    cultureId,
    companyGroupId,
  }: {
    envId: number;
    cultureId: number;
    companyId: number | null;
    companyGroupId: number | null;
  }) => {
    return request({
      url: `hiiko_environment/${envId}/yield/by-culture/${cultureId}`,
      params: {
        company_id: companyId ?? undefined,
        company_group_id: companyGroupId ?? undefined,
      },
    });
  },
};

export default resourceApi;
